export default function (props: any) {
    return (
        <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="画板" transform="translate(-516.000000, -522.000000)">
                    <g id="计算器" transform="translate(516.000000, 522.000000)">
                        <rect id="矩形" x="0" y="0" width="52" height="52"></rect>
                        <g id="编组-25" transform="translate(10.500000, 6.000000)" stroke="#000000" strokeWidth="1.5">
                            <rect id="矩形" x="0" y="0" width="31" height="40" rx="4.53227848"></rect>
                            <rect id="矩形" x="5.60578662" y="5.43832318" width="19.7884267" height="5.5572865" rx="0.906455696"></rect>
                            <rect id="矩形" x="5.60578662" y="16.3149695" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-16" x="5.60578662" y="23.5660671" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-19" x="5.60578662" y="30.8171647" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-14" x="14.0144665" y="16.3149695" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-17" x="14.0144665" y="23.5660671" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-20" x="14.0144665" y="30.8171647" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-15" x="22.4231464" y="16.3149695" width="2.97106691" height="2.83812491" rx="0.906455696"></rect>
                            <rect id="矩形备份-21" x="22.4231464" y="23.5660671" width="2.97106691" height="10.0892225" rx="0.906455696"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
